/* Ruckstuhl RC49 VAT labels + extras display – 2026-08-13 */
(function(){
'use strict';
/* RC49: each full page load starts with gross / incl. VAT. The user's
   selection still persists while they stay on the same page/configuration. */
if(!window.__rkTaxDisplayDefaulted){
  window.__rkTaxDisplayDefaulted=true;
  try{ localStorage.setItem('rk_tax_display','gross'); }catch(e){}
}
function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
function isDE(){return String(document.documentElement.lang||'de').toLowerCase().indexOf('de')===0;}
function tx(de,en){return isDE()?de:en;}
function taxInclusive(){return localStorage.getItem('rk_tax_display')!=='net';}
function currentMarket(){return window.RuckstuhlMarket&&typeof window.RuckstuhlMarket.current==='function'?window.RuckstuhlMarket.current():null;}
function taxRate(){var m=currentMarket();var r=Number(m&&m.vat_rate||0);return Number.isFinite(r)?r:0;}
function vatLabel(){var r=taxRate();return r>0?String(r.toFixed(1)).replace('.',',')+' % ':'';}
function paintTaxToggles(mode){
  qsa('[data-rk-tax-toggle]').forEach(function(b){
    var inc=mode!=='net'; b.setAttribute('aria-pressed',inc?'true':'false');
    var a=b.querySelector('[data-tax-inc]'),n=b.querySelector('[data-tax-net]');
    if(a){a.textContent=tx('inkl. '+vatLabel()+'MWST','incl. '+vatLabel()+'VAT');a.classList.toggle('is-active',inc);}
    if(n){n.textContent=tx('exkl. MWST','excl. VAT');n.classList.toggle('is-active',!inc);}
  });
}
function canonicalTaxText(net){
  net=Number(net||0);if(!Number.isFinite(net))return '';
  var market=currentMarket(), inc=taxInclusive(), amount=net, currency='CHF', suffix=inc?tx('inkl. '+vatLabel()+'MWST','incl. '+vatLabel()+'VAT'):tx('exkl. MWST','excl. VAT');
  if(window.RuckstuhlMarket){
    if(inc&&typeof window.RuckstuhlMarket.convertNet==='function')amount=window.RuckstuhlMarket.convertNet(net);
    else if(!inc&&typeof window.RuckstuhlMarket.convertNetExclusive==='function')amount=window.RuckstuhlMarket.convertNetExclusive(net);
    currency=(market&&market.currency_code)||currency;
    if(inc&&typeof window.RuckstuhlMarket.taxText==='function')suffix=window.RuckstuhlMarket.taxText();
    else if(!inc&&typeof window.RuckstuhlMarket.translate==='function')suffix=window.RuckstuhlMarket.translate('excluding_tax');
    if(typeof window.RuckstuhlMarket.formatAmount==='function')return window.RuckstuhlMarket.formatAmount(amount,currency,market)+'\u00a0'+suffix;
  }
  return currency+' '+amount.toLocaleString('de-CH',{minimumFractionDigits:2,maximumFractionDigits:2})+' '+suffix;
}
function canonicalTaxUnitText(net,basis){
  net=Number(net||0);if(!Number.isFinite(net))return '';
  var market=currentMarket(), inc=taxInclusive(), amount=net, currency='CHF';
  var suffix=inc?tx('inkl. '+vatLabel()+'MWST','incl. '+vatLabel()+'VAT'):tx('exkl. MWST','excl. VAT');
  var unit=String(basis||'Stk').toLowerCase().replace('²','2').replace(/\s+/g,'')==='m2'?' / m²':' / Stk';
  if(window.RuckstuhlMarket){
    if(inc&&typeof window.RuckstuhlMarket.convertNet==='function')amount=window.RuckstuhlMarket.convertNet(net);
    else if(!inc&&typeof window.RuckstuhlMarket.convertNetExclusive==='function')amount=window.RuckstuhlMarket.convertNetExclusive(net);
    currency=(market&&market.currency_code)||currency;
    if(inc&&typeof window.RuckstuhlMarket.taxText==='function')suffix=window.RuckstuhlMarket.taxText();
    else if(!inc&&typeof window.RuckstuhlMarket.translate==='function')suffix=window.RuckstuhlMarket.translate('excluding_tax');
    if(typeof window.RuckstuhlMarket.formatAmount==='function')return window.RuckstuhlMarket.formatAmount(amount,currency,market)+unit+'\u00a0'+suffix;
  }else if(inc){
    var r=taxRate(); if(r>1)r=r/100; amount=net*(1+r);
  }
  return currency+' '+amount.toLocaleString('de-CH',{minimumFractionDigits:2,maximumFractionDigits:2})+unit+' '+suffix;
}
function renderCanonicalTaxPrices(){
  qsa('[data-rk-net-price]').forEach(function(node){
    var net=Number(node.dataset.rkNetPrice);if(!Number.isFinite(net))return;
    var text=canonicalTaxText(net);if(text&&node.textContent!==text)node.textContent=text;
  });
}
function syncVisibleTaxPrices(){
  qsa('.rk-at-modal.is-open,.rk-tile-modal:not([hidden]),.rk-maglia.is-open,.rk-rb-modal.is-open').forEach(function(modal){
    var target=modal.querySelector('[data-rk-at-footer-price]');
    var portaMode=String(modal.dataset.rkSelectedMode||'');
    var portaRug=modal.matches&&modal.matches('.rk-at-modal[data-rk-porta-version]')&&(portaMode==='rug'||portaMode==='intarsia');
    if(portaRug&&target){
      /* PORTA Abgepasst und Logo/Intarsie besitzen ihren Preis selbst. Nie mehr den
         versteckten tk-drawer als globale Preisquelle darüberkopieren. */
      var ownedNet=Number(target.dataset&&target.dataset.rkNetPrice);
      if(Number.isFinite(ownedNet)&&ownedNet>0)target.textContent=canonicalTaxText(ownedNet);
      return;
    }
    var source=modal.querySelector('[id$="-price-total"],[data-tk-footer-price]');
    if(source&&target&&source!==target){
      if(source.dataset&&source.dataset.rkNetPrice)target.dataset.rkNetPrice=source.dataset.rkNetPrice;
      var net=Number(target.dataset&&target.dataset.rkNetPrice);
      target.textContent=Number.isFinite(net)?canonicalTaxText(net):(source.textContent||target.textContent);
    }
  });
  renderCanonicalTaxPrices();
}
function setTax(mode){
  mode=mode==='net'?'net':'gross';
  localStorage.setItem('rk_tax_display',mode);
  paintTaxToggles(mode);
  window.dispatchEvent(new CustomEvent('rk:tax-display-change',{detail:{mode:mode}}));
  setTimeout(syncVisibleTaxPrices,0);
  setTimeout(syncVisibleTaxPrices,40);
  setTimeout(syncVisibleTaxPrices,140);
  setTimeout(function(){if(window.RuckstuhlMarket&&typeof window.RuckstuhlMarket.refresh==='function')window.RuckstuhlMarket.refresh();syncVisibleTaxPrices();},180);
}
function injectTaxToggles(){
  qsa('[data-tk-footer-price], .rk-at-footer__price strong, [data-rk-tile-price], [data-sticky-price], [data-rk-rb-price]').forEach(function(price){
    var host=price.parentElement;
    if(!host||host.querySelector('[data-rk-tax-toggle]'))return;
    var b=document.createElement('button');
    b.type='button'; b.className='rk-tax-toggle'; b.setAttribute('data-rk-tax-toggle','');
    b.innerHTML='<span data-tax-net></span><i aria-hidden="true"></i><span data-tax-inc></span>';
    b.addEventListener('click',function(){setTax(taxInclusive()?'net':'gross');});
    host.appendChild(b);
  });
  paintTaxToggles(localStorage.getItem('rk_tax_display')||'gross');
  syncVisibleTaxPrices();
}
window.RKTaxDisplay={
  isInclusive:taxInclusive,
  formatNet:canonicalTaxText,
  formatNetUnit:canonicalTaxUnitText,
  set:setTax,
  refresh:function(){paintTaxToggles(localStorage.getItem('rk_tax_display')||'gross');syncVisibleTaxPrices();}
};
function svgData(svg){
  if(!svg)return '';
  try{
    var c=svg.cloneNode(true);c.setAttribute('xmlns','http://www.w3.org/2000/svg');
    return 'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(new XMLSerializer().serializeToString(c));
  }catch(e){return '';}
}
function svgPrintMarkup(svg){
  if(!svg)return '';
  try{
    var c=svg.cloneNode(true);
    c.setAttribute('xmlns','http://www.w3.org/2000/svg');
    c.removeAttribute('class');
    var source=[svg].concat(Array.prototype.slice.call(svg.querySelectorAll('*')));
    var clone=[c].concat(Array.prototype.slice.call(c.querySelectorAll('*')));
    var props=['fill','fill-opacity','stroke','stroke-opacity','stroke-width','stroke-dasharray','stroke-dashoffset','stroke-linecap','stroke-linejoin','opacity','font-family','font-size','font-style','font-weight','letter-spacing','text-anchor','dominant-baseline','visibility','display'];
    source.forEach(function(node,i){
      var target=clone[i]; if(!target||!window.getComputedStyle)return;
      var cs=window.getComputedStyle(node);
      props.forEach(function(prop){var v=cs.getPropertyValue(prop);if(v&&v!=='normal'&&v!=='auto')target.style.setProperty(prop,v);});
    });
    /* Klassen der Bahnenware-Skizze explizit inline sichern. Einige Browser
       liefern für SVG-fill im neuen Print-Dokument sonst den SVG-Default schwarz. */
    Array.prototype.forEach.call(c.querySelectorAll('.rk-material'),function(el){el.style.setProperty('fill','none','important');el.style.setProperty('stroke','#9da1a5','important');el.style.setProperty('stroke-width','1.3','important');el.style.setProperty('stroke-dasharray','5 4','important');});
    Array.prototype.forEach.call(c.querySelectorAll('.rk-rug'),function(el){el.style.setProperty('fill','#e8e5df','important');el.style.setProperty('stroke','#242f3c','important');el.style.setProperty('stroke-width','2','important');});
    Array.prototype.forEach.call(c.querySelectorAll('.rk-rest'),function(el){el.style.setProperty('fill','#f7f6f3','important');el.style.setProperty('stroke','#9da1a5','important');el.style.setProperty('stroke-width','1.3','important');el.style.setProperty('stroke-dasharray','5 4','important');});
    Array.prototype.forEach.call(c.querySelectorAll('.rk-seam'),function(el){el.style.setProperty('fill','none','important');el.style.setProperty('stroke','#242f3c','important');el.style.setProperty('stroke-width','1.5','important');el.style.setProperty('stroke-dasharray','4 3','important');});
    Array.prototype.forEach.call(c.querySelectorAll('text'),function(el){el.style.setProperty('fill','#242f3c','important');el.style.setProperty('font-family','Avenir Next, Avenir, Arial, sans-serif','important');});
    c.style.width='100%';c.style.height='100%';c.style.display='block';c.style.background='#fff';
    return new XMLSerializer().serializeToString(c);
  }catch(e){return '';}
}
function addCurrentVisuals(detail){
  var modal=document.querySelector('.rk-at-modal.is-open,.rk-maglia.is-open,[data-rk-configurator].is-open,.rk-tile-modal:not([hidden]),.rk-rb-modal.is-open');
  if(!modal)return detail;
  var imgs=Array.isArray(detail.preview_images)?detail.preview_images.slice():[];
  function srcOf(node){return node?String(node.currentSrc||node.src||'').trim():'';}
  function add(src){src=String(src||'').trim();if(src&&imgs.indexOf(src)<0)imgs.push(src);}

  var carpet=modal.querySelector('.rk-at-preview__color:not([hidden]),[data-rk-at-preview-color]:not([hidden]),[data-rk-tile-preview-image],.rk-rb-preview img,.rk-rb-preview__image img');
  var edging=modal.querySelector('.rk-at-preview__edging:not([hidden]),[data-rk-at-preview-edging]:not([hidden])');
  var sketch=modal.querySelector('[data-rk-v8-material-sketch] svg,.rk-at-preview__sketch svg,[data-rk-sketch] svg,.rk-maglia [data-persistent-drawing],.rk-maglia [data-drawing],.rk-maglia svg[data-persistent-drawing],.rk-maglia svg[data-drawing]');

  var carpetSrc=srcOf(carpet)||String(detail.carpet_image||detail.preview_image||'').trim();
  var edgingSrc=srcOf(edging)||String(detail.edging_image||'').trim();
  var sketchSrc=svgData(sketch)||String(detail.sketch_image||'').trim();
  var sketchMarkup=svgPrintMarkup(sketch)||String(detail.sketch_svg||detail.preview_svg||'').trim();

  if(carpetSrc){detail.carpet_image=carpetSrc;if(!detail.preview_image)detail.preview_image=carpetSrc;add(carpetSrc);}
  if(edgingSrc){detail.edging_image=edgingSrc;add(edgingSrc);}
  if(sketchSrc){detail.sketch_image=sketchSrc;add(sketchSrc);}
  if(sketchMarkup)detail.sketch_svg=sketchMarkup;

  qsa('[data-rk-preview-image]:not([hidden])',modal).forEach(function(i){add(srcOf(i));});
  detail.preview_images=imgs.filter(Boolean);
  if(!detail.preview_image&&detail.preview_images.length)detail.preview_image=detail.preview_images[0];
  return detail;
}
function wrapCore(){
  if(!window.RKConfiguration||window.RKConfiguration.__rc45)return false;
  ['pdf','open','pdfLegacy'].forEach(function(name){
    var old=window.RKConfiguration[name];if(typeof old!=='function')return;
    window.RKConfiguration[name]=function(detail){arguments[0]=addCurrentVisuals(detail||{});return old.apply(this,arguments);};
  });
  window.RKConfiguration.__rc45=true;return true;
}
function portaSizeGuard(modal){
  if(!modal||modal.__rc45Size)return;modal.__rc45Size=true;
  function n(el){return parseFloat(String(el&&el.value||'0').replace(',','.'))||0;}
  function check(e){
    var t=e.target;if(!t||!t.matches('input[id$="-m2"],input[id$="-width"],input[id$="-length"],input[id$="-diameter"]'))return;
    var checked=modal.querySelector('.tk-config-mode:checked,[name*="mode"]:checked'),mode=String(checked&&checked.value||'').toLowerCase();
    var m2=modal.querySelector('input[id$="-m2"]'),w=modal.querySelector('input[id$="-width"]'),l=modal.querySelector('input[id$="-length"]'),d=modal.querySelector('input[id$="-diameter"]');
    if(mode==='m2'){
      if(m2&&n(m2)>20){m2.value='20';m2.setCustomValidity(tx('Maximal 20 m².','Maximum 20 m².'));m2.reportValidity();setTimeout(function(){m2.setCustomValidity('');m2.dispatchEvent(new Event('change',{bubbles:true}));},0);}
      return;
    }
    if(mode==='rug'||mode==='intarsia'){
      if(w&&n(w)>3)w.value='3.00';
      if(l&&n(l)>3)l.value='3.00';
      var invalid=(w&&n(w)>0&&n(w)<0.3)||(l&&n(l)>0&&n(l)<0.3);
      t.setCustomValidity(invalid?tx('PORTA Abgepasst: Breite und Länge 0,30 bis 3,00 m.','PORTA rugs: width and length 0.30 to 3.00 m.'):'');
      return;
    }
    var shape=String((modal.querySelector('[id$="-shape"]')||{}).value||'').toLowerCase();
    var area=shape==='rund'?Math.PI*Math.pow(n(d)/2,2):n(w)*n(l);
    if(area>29){t.setCustomValidity(tx('PORTA ist in dieser Ausführung bis maximal 29 m² möglich.','PORTA is available in this configuration up to 29 m².'));t.reportValidity();}
    else t.setCustomValidity('');
  }
  modal.addEventListener('input',check,true);modal.addEventListener('change',check,true);
}
var openScroll=0;
document.addEventListener('click',function(e){
  if(e.target.closest('[data-rk-configurator-trigger],.rk-at-trigger,[data-open-configurator]'))openScroll=window.scrollY;
  if(e.target.closest('.rk-at-modal__close,[data-rk-close],[data-close-configurator]')){
    var y=openScroll;setTimeout(function(){window.scrollTo(0,y);},0);
  }
},true);
function enhance(){
  injectTaxToggles();
  qsa('.rk-at-modal--porta,.rk-at-modal[data-configurator-type="porta"]').forEach(function(m){portaSizeGuard(m);});
}
function init(){
  enhance();
  var tries=0,t=setInterval(function(){if(wrapCore()||++tries>80)clearInterval(t);},100);
  new MutationObserver(function(rs){if(rs.some(function(r){return r.addedNodes&&r.addedNodes.length;}))requestAnimationFrame(enhance);}).observe(document.body,{childList:true,subtree:true});
}
window.addEventListener('tk:price:update',function(){setTimeout(syncVisibleTaxPrices,0);setTimeout(syncVisibleTaxPrices,60);});
window.addEventListener('ruckstuhl:market-change',function(){setTimeout(function(){paintTaxToggles(localStorage.getItem('rk_tax_display')||'gross');syncVisibleTaxPrices();},0);});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();